import React, { useContext } from 'react';
import { Button, Card, LocaleContext } from 'shared';

import { AccountNameProps } from './AccountName.types';

export const AccountName = ({ onOpenEditModal, account }: AccountNameProps) => {
  const localeContext = useContext(LocaleContext);

  return (
    <Card className="account-name">
      <Card.Header className="account-name__header">
        <Card.Title className="account-name__title">
          {localeContext.formatMessage({ id: 'ACCOUNT.ACCOUNT-NAME' })}:
        </Card.Title>
        <Button
          type={'portal-lite'}
          icon={['1.25rem', 'pencilBlueIcon']}
          iconAfterText={true}
          onClick={onOpenEditModal}
          className="button--edit-account"
        >
          {localeContext.formatMessage({ id: 'ACCOUNT.EDIT-SECTION' })}
        </Button>
      </Card.Header>
      <Card.Body className="account-name__body">
        <Card.Item className="account-name__name">
          <Card.ItemKey className="account-name__key">
            {localeContext.formatMessage({ id: 'ACCOUNT.ACCOUNT-NAME' })}:
          </Card.ItemKey>
          <Card.ItemValue className="account-name__value">{account.name}</Card.ItemValue>
        </Card.Item>
      </Card.Body>
    </Card>
  );
};
